import axios from "axios";
import { link } from "./url";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
// Add customer API
export const addCustomer = async (customer) => {
  const res = await axios.post(link + "salman/add", customer);
  return res.data;
};

// Fetch all customers
export const getCustomers = async () => {
  const res = await axios.get(link + "salman/");
  return res.data;
};

// Delete customer
export const deleteCustomer = async (id) => {
  await axios.post(link + "salman/deletecustomer", { id });
  return id; // return deleted id for cache update
};

// 🔍 Search customer by name/area/mobile
export const searchCustomer = async (search) => {
  const res = await axios.post(link + "salman/searchcustomer", { search });
  return res.data;
};

// ➕ Add new sale
export const addSale = async (data) => {
  const res = await axios.post(link + "salman/addsales", data);
  return res.data;
};

// API function
const fetchBillDetails = async (sid) => {
  const res = await axios.post(link + "salman/viewbill", { sid });
  return res.data.bill;
};

// Custom hook for Viewsales
export const useBillDetails = (sid) => {
  return useQuery({
    queryKey: ["billDetails", sid],
    queryFn: () => fetchBillDetails(sid),
    enabled: !!sid, // fetch only if sid exists
  });
};

// API call
const addNegativeBill = async (payload) => {
  const res = await axios.post(link + "salman/addnegativebill", payload);
  return res.data;
};

// Custom Hook
export const useAddNegativeBill = () => {
  return useMutation({
    mutationFn: addNegativeBill,
  });
};

// 🔹 Fetch bills list
const fetchBills = async ({ queryKey }) => {
  const [, params] = queryKey; // Get the second element (the params object)
  console.log("Fetching bills for:", params.date, params.date1);

  const res = await axios.post(link + "salman/bill", {
    curdate: params.date,
    curdate1: params.date1,
  });
  console.log("Fetched bills data:", res.data);
  return res.data;
};
// 🔹 Add bill
const addBill = async (bill) => {
  console.log(bill);
  return axios.post(link + "salman/addbill", { v: bill });
};

// 🔹 Update shift
const updateShift = async ({ id, value }) => {
  return axios.post(link + "salman/updateshift", { id, value });
};

const updateTiming = async ({ id, value }) => {
  return axios.post(link + "salman/updatetiming", { id, value });
};

// 🔹 Update message (sms toggle)
const updateMessage = async ({ id, message }) => {
  return axios.post(link + "salman/updatemessage", { i: id, message });
};

// 🔹 Add amount
const addAmount = async ({ id, amount, mobile, message }) => {
  return axios.post(link + "salman/addamount", {
    id,
    amount,
    mobile,
    message,
  });
};

// ==================
// 🔹 Custom Hooks
// ==================
export const useBills = (date, date1) =>
  useQuery({
    queryKey: ["bills", { date, date1 }],
    queryFn: fetchBills,
  });

export const useAddBill = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addBill,

    // ❗ use this ONLY if you want refresh
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bills"] });
    },
  });
};
export const useUpdateShift = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateShift,
    onSuccess: () => queryClient.invalidateQueries(["bills"]),
  });
};

export const useUpdateTiming = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateTiming,
    onSuccess: () => queryClient.invalidateQueries(["bills"]),
  });
};

export const useUpdateMessage = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateMessage,
    onSuccess: () => queryClient.invalidateQueries(["bills"]),
  });
};

export const useAddAmount = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: addAmount,
    onSuccess: () => queryClient.invalidateQueries(["bills"]),
  });
};
export const fetchSales = async () => {
  const res = await axios.get(link + "salman/sales");

  return res.data;
};

export const updateSalesStatus = async (rowData) => {
  await axios.post(link + "salman/salesupdate", { va: rowData });
};

export const deleteSales = async (id) => {
  await axios.post(link + "salman/deletesales", { id });
};

// Fetch all completed sales
export const fetchAllSales = async () => {
  const res = await axios.get(link + "salman/allsales");
  return res.data;
};

// Fetch bill report for a single date
export const fetchBillReport = async (date) => {
  const res = await axios.post(link + "salman/billreport", { curdate: date });
  return res.data;
};

// Fetch bill report for a date range
export const fetchBillFullReport = async (date, date1) => {
  const res = await axios.post(link + "salman/billfulreport", {
    curdate: date,
    curdate1: date1,
  });
  return res.data;
};

// Delete a bill entry
export const deleteBillApi = async (entry) => {
  await axios.post(link + "salman/deletebill", { d: entry });
};

// Fetch names for autocomplete
export const fetchNames = async () => {
  const res = await axios.post(link + "salman/getname");
  return res.data;
};

// Add a purchase
export const addPurchase = async ({ value, price, purchase }) => {
  await axios.post(link + "salman/addpurchase", { value, price, purchase });
};

// Fetch purchase report by date
export const fetchPurchaseReport = async ({ date, date1 }) => {
  const res = await axios.post(link + "salman/getall", {
    curdate: date,
    curdate1: date1,
  });
  return res.data;
};

// Delete purchase by ID
export const deletePurchase = async (id) => {
  await axios.post(link + "salman/deletepurchase", { id });
};

export const fetchViewSaless = async () => {
  const res = await axios.post(link + "salman/viewsaless");
  console.log("API Response:", res.data); // check if backend returns data
  return res.data;
};

export const useSalesCount = () =>
  useQuery({
    queryKey: ["sales-count"],
    queryFn: async () => {
      const res = await axios.get(link + "salman/sales-count");
      return res.data;
    },
  });

// in api.js
export const useMoveNextDate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await axios.post(link + "salman/next-date");
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["sales-count"]); // refresh counts
    },
  });
};
